// Base64 Tool — encode and decode text to/from Base64 (UTF-8 safe).
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const base64Tool: Tool = {
  id: "base64-tool",
  name: () => m.b64_tool_name(),
  description: () => m.b64_tool_description(),
  icon: "🔣",
  basePath: "/base64",
  status: "stable",
  tags: ["base64", "encode", "decode", "developer"],
  pages: [
    {
      name: () => m.b64_nav_main(),
      path: "/base64",
      description: () => m.b64_nav_main_desc(),
      icon: "🔣",
    },
  ],
};
